import React, { Component } from "react";

class Navbar extends Component {
  render() {
    return (
      <nav>
        <h1>Sorting Visualization</h1>
      </nav>
    );
  }
}

export default Navbar;
